;;  ;;   ;;     ;;;    ;;; ;;
  ;;   ;;  ;;   ;;;;  ;;;; ;;
  ;;  ;;    ;;  ;; ;;;; ;; ;;
  ;;  ;;;;;;;;  ;;  ;;  ;;
  ;;  ;;    ;;  ;;      ;; ;;


import "./config.js";
import "./helpers/jqcookie.js"
import "./helpers/slim-select.js";
import "./helpers/slim-select.jquery.js";
import "./models/filters/index.js"
import {onLoad as o0} from "./helpers/datastore.js"
import "./anime/edit/index.js"
import "./helpers/material-effects.js";
import "./profile/index.js";
import "./interface.js";
import "./models/trailers/index.js";
import "./helpers/scroller.js";
import "./messages.js";
import "./notifications.js";
import "./comments.js";
import "./chatter.js";
import "./search.js";
import "./helpers/autolinker.js";
import "./dialogs/preview-anime.js";
import "./anime/index.js";
import "./custom-elements/index.js";
import "./moderator.js";
import "./iframe-apis/index.js";
import "./videoblogger/index.js"
import "./dialogs/SettingsDialog.js";
import "./modifications/index.js"
import {onLoad as o2} from "./reviews.js";
import {onLoad as o3} from "./helpers/bbutils.js";
import "./models/chat/index.js"
import "./models/news/AddPostForm.js";
import "./models/Footer.js";
import "./models/comments/index.js";
import "./models/apps/index.js"
for(let i of [o0, o2, o3])
    $(i);

export {};

(window as any).scriptLoaded=true;